export default __webpack_public_path__ + "static/media/body_background_geometric_spirals_dark_01_bottom_right.eb97ae2c.png";